if (!customElements.get('mobile-purchase-bar')) {
  customElements.define('mobile-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('[data-wp-buy], product-info');
      if (!this.scope) return;
      this.add = this.querySelector('[data-mobile-add]');
      this.price = this.querySelector('[data-mobile-price]');
      this.selection = this.querySelector('[data-mobile-selection]');
      this.wallpaper = this.scope.matches('[data-wp-buy]');
      this.onAdd = () => {
        const source = this.sourceButton();
        if (source && !this.add.disabled) source.click();
      };
      this.onOptions = () => {
        const target = this.scope.querySelector('.sophestia-personalization input[required]') ||
          this.scope.querySelector('[data-wp="mode"], variant-selects select, variant-selects input');
        if (!target) return;
        const group = target.closest('fieldset, variant-selects, .sophestia-personalization') || target;
        group.scrollIntoView({ block: 'center' });
        target.focus({ preventScroll: true });
      };
      this.onInput = () => this.update();
      this.onFocus = () => {
        const active = document.activeElement;
        this.toggleAttribute('data-editing', !!active && this.scope.contains(active) &&
          active.matches('textarea, input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"])'));
      };
      this.add.addEventListener('click', this.onAdd);
      this.querySelector('[data-mobile-options]').addEventListener('click', this.onOptions);
      this.scope.addEventListener('input', this.onInput);
      this.scope.addEventListener('change', this.onInput);
      document.addEventListener('focusin', this.onFocus);
      document.addEventListener('focusout', this.onFocus);
      this.observer = new MutationObserver((records) => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      this.observer.observe(this.scope, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'value']
      });
      this.update();
    }

    sourceButton() {
      return this.scope.querySelector(this.wallpaper ? '[data-wp="submit"]' : 'product-form [type="submit"]');
    }

    text(element, value) {
      if (element.textContent !== value) element.textContent = value;
    }

    update() {
      const source = this.sourceButton();
      const form = source?.form;
      const priceRoot = this.wallpaper ? this.scope.querySelector('[data-wp="total-price"]') :
        this.scope.querySelector('[id^="price-"]');
      if (!source || !form || !priceRoot) {
        this.hidden = true;
        this.removeAttribute('data-ready');
        return;
      }
      let amount;
      let summary;
      if (this.wallpaper) {
        amount = priceRoot.textContent.trim();
        summary = this.scope.querySelector('[data-wp="total-count"]')?.textContent.trim() || '';
        const height = this.scope.querySelector('[data-wp="height"]');
        if (this.scope.querySelector('[data-wp="mode"]:checked')?.value !== 'sample' && height) {
          summary += ' · ' + height.selectedOptions[0].textContent.trim();
        }
        const material = this.scope.querySelector('[data-wp="material"]:checked');
        if (material) summary += ' · ' + material.value;
      } else {
        const price = priceRoot.querySelector('.price');
        const amountNode = price?.querySelector(price.classList.contains('price--on-sale') ?
          '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
        amount = amountNode?.textContent.trim() || '';
        const quantity = form.elements.namedItem('quantity')?.value || '1';
        if (amount && Number(quantity) > 1) amount = quantity + ' × ' + amount;
        summary = Array.from(this.scope.querySelectorAll('variant-selects select'))
          .map(select => select.selectedOptions[0]?.textContent.trim()).filter(Boolean).join(' / ');
        if (!summary) summary = Array.from(this.scope.querySelectorAll('variant-selects input:checked'))
          .map(input => input.value).join(' / ');
      }
      this.text(this.price, amount);
      this.text(this.selection, summary);
      this.text(this.add, source.textContent.trim());
      this.add.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true' ||
        priceRoot.classList.contains('hidden') || !amount || amount === '—';
      if (this.watchedSource !== source) {
        this.intersection?.disconnect();
        this.watchedSource = source;
        this.intersection = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-inline-visible', entry.isIntersecting);
        });
        this.intersection.observe(source);
      }
      this.hidden = false;
      this.setAttribute('data-ready', '');
    }

    disconnectedCallback() {
      this.add?.removeEventListener('click', this.onAdd);
      this.querySelector('[data-mobile-options]')?.removeEventListener('click', this.onOptions);
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.scope?.removeEventListener('input', this.onInput);
      this.scope?.removeEventListener('change', this.onInput);
      document.removeEventListener('focusin', this.onFocus);
      document.removeEventListener('focusout', this.onFocus);
    }
  });
}
